module.exports = __webpack_public_path__ + "img/awake-bot-avatar.d7f1bd5a.png";